var isDated = function (issue) {
    return Boolean(issue.expectedDate);
};
// undated issues (specials) used to be dropped by the date-driven grids; unplaced feeds their own band
export function placeIssues(issues) {
    var datedIds = new Set(issues.filter(isDated).map(function (issue) { return issue.id; }));
    var dated = [];
    var followersByParentId = new Map();
    var unplaced = [];
    issues.forEach(function (issue) {
        var _a;
        if (isDated(issue)) {
            dated.push(issue);
            return;
        }
        var parentId = issue.parentIssueId;
        if (parentId && datedIds.has(parentId)) {
            var followers = (_a = followersByParentId.get(parentId)) !== null && _a !== void 0 ? _a : [];
            followers.push(issue);
            followersByParentId.set(parentId, followers);
            return;
        }
        unplaced.push(issue);
    });
    return { dated: dated, followersByParentId: followersByParentId, unplaced: unplaced };
}
